<template>
  <div>
    <div class="content-header">
      <h1>Tlačové zostavy</h1>
    </div>
    <section class="content">
      <div class="box box-solid">
        <div class="box-body">
          <div class="box-group" id="accordion">
            <div class="panel box box-primary">
              <div class="box-header with-border">
                <h4 class="box-title">
                  <a data-toggle="collapse" data-parent="#accordion" href="#collapseOne" aria-expanded="false">
                    Dodacie listy
                  </a>
                </h4>
              </div>
              <div id="collapseOne" class="panel-collapse collapse collapsed" aria-expanded="false" style="height: 0px;">
                <div class="box-body">
                  <div class="pull-left">
                    <div class="inline-block block">
                      <date-field v-model="deliveryNoteDate"
                                  field-id="deliveryNoteDate"></date-field>
                    </div>
                    <div class="inline-block block">
                      <button class="btn btn-primary" @click.prevent="printDeliveryNotes()">Tlač</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="panel box box-primary">
              <div class="box-header with-border">
                <h4 class="box-title">
                  <a data-toggle="collapse" data-parent="#accordion" href="#collapseTwo" class="collapsed" aria-expanded="false">
                    Plán rozvozu
                  </a>
                </h4>
              </div>
              <div id="collapseTwo" class="panel-collapse collapse collapsed" aria-expanded="false" style="height: 0px;">
                <div class="box-body">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="pull-left">
                        <div class="inline-block block">
                          <date-field v-model="orderDate"
                                      field-id="orderDate"></date-field>
                        </div>
                        <div class="inline-block block">
                          <button class="btn btn-primary" @click.prevent="printOrders()">Tlač</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="panel box box-primary" v-if="hasRole('DEALER')">
              <div class="box-header with-border">
                <h4 class="box-title">
                  <a data-toggle="collapse" data-parent="#accordion" href="#collapseThree" class="collapsed" aria-expanded="false">
                    Podklad pre fakturáciu
                  </a>
                </h4>
              </div>
              <div id="collapseThree" class="panel-collapse collapse  collapsed" aria-expanded="false">
                <div class="box-body">

                  <form data-vv-scope="invoiceDataForm">
                    <div class="row">
                      <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
                        <select-field field-id="customer"
                                      label="Zákazník"
                                      :options="customers"
                                      v-model="selectedCustomer"
                                      scope="invoiceDataForm"
                                      validation="required"/>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
                        <date-field v-model="invoiceDataDateFrom"
                                    field-id="dateFrom"
                                    label="Obdobie od"
                                    validation="required"
                                    scope="invoiceDataForm"
                        ></date-field>
                      </div>
                      <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
                        <date-field v-model="invoiceDataDateTo"
                                    field-id="dateTo"
                                    label="Do"
                                    validation="required"
                                    scope="invoiceDataForm"
                        ></date-field>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xs-12">
                        <button class="btn btn-primary" @click.prevent="printInvoiceData()">Tlač</button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import _ from 'lodash';
  import moment from 'moment';
  import validationMixin from 'components/validationMixin';
  import dateField from 'components/form/dateField';
  import selectField from 'components/form/selectField';
  import notificationService from 'services/notificationService';

  export default {
    components: { dateField, selectField},
    mixins: [validationMixin],
    data: () => ({
        orderDate: null,
        deliveryNoteDate: null,
        selectedCustomer: null,
        invoiceDataDateFrom: null,
        invoiceDataDateTo: null
    }),
    computed: {
      ...mapGetters({
        customers: 'customer/activeItems',
        hasRole: 'auth/hasRole'
      })
    },
    methods: {
      printDeliveryNotes() {
        this.$router.push('/delivery-notes/print');
      },
      printOrders() {
        this.$router.push('/orders/print');
      },
      printInvoiceData() {

        this.$validator.validateAll('invoiceDataForm').then((res) => {
          if (res) {
            if (this.invoiceDataDateFrom.isAfter(this.invoiceDataDateTo)) {
              return notificationService.error('error.invoiceData.date.invalid');
            }
  //          this.$store.dispatch('invoiceData/setFilter', {dateFrom: this.invoiceDataDateFrom, dateTo: this.invoiceDataDateTo, customerId: this.selectedCustomer.value});
            this.$router.push('/invoice-data/print');
          }
        });
      },
      setInvoiceDataFilter() {
        this.$store.dispatch('invoiceData/setFilter', {dateFrom: this.invoiceDataDateFrom, dateTo: this.invoiceDataDateTo, customerId: this.selectedCustomer ? this.selectedCustomer.id : null});
      }
    },
    watch: {
        orderDate(date) {
          this.$store.dispatch('order/setFilterDate',  date);
        },
        deliveryNoteDate(date) {
          this.$store.dispatch('deliveryNote/setFilterDate',  date);
        },
        invoiceDataDateFrom() {
          this.setInvoiceDataFilter();
        },
        invoiceDataDateTo() {
          this.setInvoiceDataFilter();
        },
        selectedCustomer() {
          this.setInvoiceDataFilter();
        },
    },
    mounted () {
      this.orderDate = moment();
      this.deliveryNoteDate = moment(this.$store.state.deliveryNote.filterDate);
      this.invoiceDataDateFrom = moment(this.$store.state.invoiceData.filter.dateFrom);
      this.invoiceDataDateTo = moment(this.$store.state.invoiceData.filter.dateTo);
      const customerId = this.$store.state.invoiceData.filter.customerId;
      if (customerId) {
        this.selectedCustomer = _.find(this.customers, {id: customerId});
      }
      this.$store.dispatch('customer/setFilterArea', null);  //print for all areas
      this.$store.dispatch('customer/setFilterCompanyName', null); //print for all customers

      this.$store.dispatch('deliveryNote/setFilterCustomer', null); //print for all customers
    },
    created() {
      this.$store.dispatch('customer/getAll');
    }
  }
</script>



// WEBPACK FOOTER //
// client/views/reports.vue